export default "__VITE_ASSET__B6X7YOW___"